import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Col, Image, Row, Table, Spinner } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { viewUser } from "../../../api/userService";
import Avatar from "../../../assets/img/default.jpg";
export default function BasicInfo() {
  const [user, setUser] = useState({});
  const [loading, setLoading] = useState(true);

  const { userId } = useParams();

  useEffect(() => {
    if (userId) {
      fetchUser(userId);
    }
  }, [userId]);

  const fetchUser = async (userId) => {
    setLoading(true);
    try {
      const response = await viewUser({ userId });
      if (response.code === 200) {
        setUser(response.data);
      } else {
        console.warn("Unexpected response code:", response.code);
      }
    } catch (error) {
      console.error("Error fetching user details", error);
    } finally {
      setLoading(false); // Always stop loading
    }
  };
  const displayInfo = (info) => {
    return info ? info : "N/A";
  };

  const getStatusStyle = (status) => {
    switch (status) {
      case "Active":
        return {
          backgroundColor: "rgba(40, 199, 111, 0.12)",
          color: "#28c76f",
          padding: "1px 4px",
          fontSize: '14px',
          borderRadius: "5px",
          display: "inline-block",
        };
      case "Inactive":
        return {
          backgroundColor: "rgba(146, 0, 0, 0.12)",
          color: "#920000",
          padding: "1px 4px",
          fontSize: '14px',
          borderRadius: "5px",
          display: "inline-block",
        };
      default:
        return {};
    }
  };

  // console.log('===1111111111======user', user)

  const MEDIA_URL = 'https://d3bn54rc14fhr4.cloudfront.net';

  const imageUrl = user.profilePic ? `${MEDIA_URL}/${user.profilePic}` : Avatar

  const userinfo = {
    image: imageUrl,
    name: displayInfo(user.fullName),
    email: displayInfo(user.email),
    phoneNumber: displayInfo(user.mobileNumber
      ? user.countryCode
        ? `+${user.countryCode} ${user.mobileNumber}`
        : user.mobileNumber
      : ""),
    registrationDate: user.createdAt ? new Date(user.createdAt).toLocaleDateString() : "N/A",
    bio: displayInfo(user.bio),
    status: displayInfo(user.accountStatus),
    subscriptionStatus: displayInfo(user.SubscriptionStatus),
    username: displayInfo(user.username),
  };

  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <React.Fragment>
      <Card>
        <Card.Body className="bookingtable mt-3">
          <div className="accountuseravatar mb-5 mt-4">
            <Image src={userinfo.image} className="rounded-circle img-thumbnail img-fluid" alt="" />
          </div>
          <Row>
            <Col md={6}>
              <div className="accountgrid">
                <label>Name</label>
                <p className="mb-0">{userinfo.name}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="accountgrid">
                <label>Username</label>
                <p className="mb-0">{userinfo.username}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="accountgrid">
                <label>Email</label>
                <p className="mb-0">{userinfo.email}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="accountgrid">
                <label>Phone Number</label>
                <p className="mb-0">{userinfo.phoneNumber}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="accountgrid">
                <label>Registration Date</label>
                <p className="mb-0">{userinfo.registrationDate}</p>
              </div>
            </Col>
            <Col md={6}>
              <div className="accountgrid">
                <label>Status</label>
                <p className="mb-0"><span style={getStatusStyle(userinfo.status)}>{userinfo.status}</span></p>
              </div>
            </Col>
            <Col md={6}>
              <div className="accountgrid">
                <label>Subscription Status</label>
                <p className="mb-0">{userinfo.subscriptionStatus}</p>
              </div>
            </Col>
            <Col md={12}>
              <div className="accountgrid flex-column align-items-start">
                <label>Bio</label>
                <p className="mb-0">{userinfo.bio}</p>
              </div>
            </Col>
          </Row>


        </Card.Body>
      </Card>
    </React.Fragment>
  );


}
